module.exports = __webpack_public_path__ + "static/img/icon_cloud_item4.1642114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud_item4.jpg
// module id = Ywwk
// module chunks = 21